import { Link } from "react-router-dom";
import AuthLayout from "@/components/AuthLayout";

export default function PaymentCancel() {
  return (
    <AuthLayout eyebrow="Checkout" title={null}>
      <div data-testid="payment-cancel-panel" className="glass-panel p-8 sm:p-12 text-center mt-8">
        <h2 className="font-serif text-3xl text-amber-100/95 mb-3">Checkout <span className="italic gold-text">cancelled</span></h2>
        <p className="text-sm text-neutral-400 font-light leading-relaxed mb-8">
          No charge was made. Whenever you're ready, the Society will be here.
        </p>
        <Link to="/membership" data-testid="payment-cancel-back-link" className="inline-block px-8 py-3 bg-gold text-obsidian text-xs uppercase tracking-[0.2em] font-medium hover:bg-gold-bright transition-colors">
          Return to Membership
        </Link>
      </div>
    </AuthLayout>
  );
}
